import { atom } from 'jotai'

export const secondaryOptionsVisibleAtom = atom<boolean>(false)
